import React from 'react'

const ReportStatus = ({ radiologyReportFormData, handleChange }) => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center gap-4">
                    <h4 className="mb-4">Report Status : </h4>
                    <div className="form-group d-flex align-items-center gap-4">
                        {["Final", "In progress"].map((status) => (
                            <div className="form-check me-3" key={status}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="labReportStatus"
                                    id={status.toLowerCase()}
                                    value={status}
                                    checked={radiologyReportFormData.labReportStatus === status}
                                    onChange={handleChange}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={status.toLowerCase()}
                                >
                                    {status}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportStatus